import React from 'react';
import { ModernHeader } from '../components/ModernHeader';
import { Footer } from '../components/Footer';
import { Shield, Eye, Database, Lock } from 'lucide-react';
export function PrivacyPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-740">
      <ModernHeader data-id="element-741" />

      {/* Page Header Banner */}
      <section className="bg-gray-800 py-12" data-id="element-742">
        <div className="max-w-7xl mx-auto px-4" data-id="element-743">
          <h1 className="text-3xl md:text-4xl font-bold text-white text-center" data-id="element-744">
            Privacy Notice
          </h1>
        </div>
      </section>

      {/* Main Content */}
      <main className="py-12 md:py-16" data-id="element-745">
        <div className="max-w-4xl mx-auto px-4 space-y-8" data-id="element-746">
          {/* Privacy Commitment Section */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 md:p-8" data-id="element-747">
            <div className="flex items-center gap-3 mb-6" data-id="element-748">
              <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center" data-id="element-749">
                <Shield className="w-5 h-5 text-blue-700" data-id="element-750" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-751">Privacy</h2>
            </div>

            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-752">
              <p data-id="element-753">
                At <strong data-id="element-754">USA Bearings & Belts</strong>, we are committed to
                giving you quality service and products. As part of that
                commitment, we gather information about our customers and
                website visitors so we can better serve you.
              </p>

              <p data-id="element-755">
                Because we realize that your privacy is important to you, your
                privacy is also important to us. Whether you fax, phone or over
                the Internet, you can be assured that we respect the
                confidentiality of personal information that identifies you and
                treat that information responsibly.
              </p>

              <div className="bg-green-50 border border-green-200 rounded-lg p-4" data-id="element-756">
                <p className="text-green-800 font-medium" data-id="element-757">
                  As described in this Privacy Statement, we do not authorize
                  the selling or renting of your personal information to third
                  parties for their business purposes.
                </p>
              </div>

              <p data-id="element-758">
                By using our site, you accept the practices that are described
                in this privacy statement, which were effective as of{' '}
                <strong data-id="element-759">December 1, 2004</strong>, and is part of the Terms and
                Conditions governing use of this site.
              </p>

              <p data-id="element-760">
                We may change or add to this statement from time to time. When
                that happens, we will post the revised statement here. Your use
                of our site after changes to this privacy statement have been
                made constitutes acceptance of those changes going forward.
              </p>

              <p className="text-sm text-gray-600 italic" data-id="element-761">
                USA Bearings & Belts is not responsible for the privacy policies
                or practices of the websites from which you access our site,
                sites we link to, or of any sites that are linked to our site.
              </p>

              <p data-id="element-762">
                This privacy statement tells you what kinds of customer
                information we collect, how we use that information and with
                whom we may share it, and how you can access and change our
                information about you.
              </p>
            </div>
          </div>

          {/* Personal Information Section */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 md:p-8" data-id="element-763">
            <div className="flex items-center gap-3 mb-6" data-id="element-764">
              <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center" data-id="element-765">
                <Database className="w-5 h-5 text-purple-700" data-id="element-766" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-767">
                What personal information do we collect from our customers?
              </h2>
            </div>

            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-768">
              <p data-id="element-769">
                Customer information is gathered so we can better serve you, and
                we make reasonable efforts to ensure the security of your
                personal information and to treat that information responsibly.
              </p>

              <p data-id="element-770">
                We collect the personal information that our customers give us
                when they choose to purchase a product from USA Bearings & Belts
                or use our site. For example, when you register with us we will
                ask you to provide your:
              </p>

              <ul className="list-disc list-inside space-y-1 ml-4" data-id="element-771">
                <li data-id="element-772">Name</li>
                <li data-id="element-773">Email address</li>
                <li data-id="element-774">Physical address</li>
                <li data-id="element-775">Telephone number</li>
              </ul>

              <p data-id="element-776">
                If you purchase a product, we will also ask you for financial
                information such as your credit card number and a shipping
                address.{' '}
                <strong data-id="element-777">
                  Registration with us is required to make a purchase.
                </strong>
              </p>

              <p data-id="element-778">
                Similarly, we will ask you for contact information if you use
                our E–mail to a Friend program, or if you request that we send
                you E-newsletters or other promotional notices or seek
                information or assistance from us.
              </p>
            </div>
          </div>

          {/* Other Information Section */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 md:p-8" data-id="element-779">
            <div className="flex items-center gap-3 mb-6" data-id="element-780">
              <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center" data-id="element-781">
                <Eye className="w-5 h-5 text-teal-700" data-id="element-782" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-783">
                What other kinds of customer information do we collect?
              </h2>
            </div>

            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-784">
              <p data-id="element-785">
                If you ask us to ship a purchase to somebody else or you use our
                E–mail to a Friend program, we will ask you for the name and
                address or e-mail address of the person to whom you are sending
                or recommending the product, as well as your name and contact
                information.
              </p>

              <p data-id="element-786">
                Our system also keeps track of which browser and Internet
                Provider (IP) you use to access our site. To help us understand
                the use of our site by our visitors and improve your shopping
                experience, we also automatically collect information as to:
              </p>

              <ul className="list-disc list-inside space-y-1 ml-4" data-id="element-787">
                <li data-id="element-788">How you were directed to the site</li>
                <li data-id="element-789">How you navigate around it</li>
                <li data-id="element-790">What products you browse</li>
                <li data-id="element-791">Your purchasing activities</li>
              </ul>
            </div>
          </div>

          {/* How We Collect Section */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 md:p-8" data-id="element-792">
            <div className="flex items-center gap-3 mb-6" data-id="element-793">
              <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center" data-id="element-794">
                <Lock className="w-5 h-5 text-orange-700" data-id="element-795" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-796">
                How do we collect this information?
              </h2>
            </div>

            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-797">
              <p data-id="element-798">
                When you register with USA Bearings & Belts, we compile the
                personal information you give us about yourself into an
                individual profile, adding other personal information about you
                to that profile as you give it to us.
              </p>

              <p data-id="element-799">
                We also collect information about your purchases and other uses
                of our site as they are made.
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-800" />
    </div>;
}